import type { ReactElement } from "react"

import { MenuItem, Typography } from "@synapse-analytics/synapse-ui"

import styles from "../Dashboard.module.scss"

type MenuItemProps = {
  id?: string
  text: string
  icon: ReactElement
  isSelected?: boolean
  onClick?: (event: React.MouseEvent<HTMLElement>) => void
  collapsed?: boolean
  endIcon?: ReactElement
}

export function DashboardMenuItem({
  id,
  text,
  icon,
  isSelected,
  onClick,
  collapsed = false,
  endIcon,
}: MenuItemProps): ReactElement {
  return (
    <MenuItem
      id={id || `${text} button`}
      isSelected={isSelected}
      onClick={onClick}
      className={`${collapsed && styles.collapsedMenuButton}`}
      data-collapsed={collapsed}
    >
      <div className={styles.menuButtonContent}>
        {icon}
        {!collapsed && (
          <Typography variant="a" variantColor={2} color={isSelected ? "important" : "base"}>
            {text}
          </Typography>
        )}
        {endIcon}
      </div>
    </MenuItem>
  )
}
